import React, { Fragment, useRef } from 'react';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';
import NoResultRC from '@/components/noresult';
import g_styles from '@/components/public.style';
import { makeStyles } from 'tss-react/mui';
import { Pagination } from '@mui/material';
import { usePageMode } from '@/model/usePageMode';
import { Grid } from '@mui/material';

/**
 * table component
 * @param {Array} titles 表头 [{key,value}]
 * @param {Array} data 数据 [{titles[0][key]:value}, {titles[1][key]:value}]
 * @param {String} className
 * @param {String} Url
 *
 */

const useStyles = makeStyles()((theme) => ({
  ...g_styles(theme),
}));

const TableRC = (props) => {
  const { classes, cx } = useStyles();
  const ref_list = useRef();
  const { bodySize } = usePageMode();
  const renderTitle = (titles = []) => {
    return (
      <div className={classnames(classes.g_table_title, props.widthStyle)}>
        {titles.map((item, i) => {
          return <div key={item.key + 'title' + i}>{item.title}</div>;
        })}
      </div>
    );
  };
  const itemClick = (record) => () => {
    props.itemClick && props.itemClick(record);
  };
  const dataItemClick = (reocrd, click) => () => {
    if (click) {
      click(reocrd);
    }
  };
  const renderBody = (data = [], dataDesc = {}, dataDescKey = '') => {
    if (!data.length && !props.loading) {
      return (
        <div className={classes.g_table_con} ref={ref_list}>
          <NoResultRC />
        </div>
      );
    }
    // 自定义表格
    if (props.children) {
      return props.children;
    }

    const titles = props.titles;
    const titles2 = props.dataDescTitles;

    return bodySize.width <= 800 ? (
      <div className={classes.g_table_con_m} ref={ref_list}>
        {data.map((item, i) => {
          return (
            <div
              key={i}
              className={classnames(classes.g_table_item_m, props.widthStyle)}
              onClick={itemClick(item)}>
              {titles.map((it, n) => {
                return (
                  <Grid
                    container
                    key={it.key + 'item' + n}
                    justifyContent={'space-between'}>
                    <Grid item>
                      {it.key == 'action' ? (
                        ''
                      ) : (
                        <span className='title_m'>{it.title}</span>
                      )}
                    </Grid>
                    <Grid item>
                      {it.render
                        ? it.render(item[it.key], item, i)
                        : item[it.key]}
                    </Grid>
                  </Grid>
                );
              })}
            </div>
          );
        })}
      </div>
    ) : (
      <div className={classes.g_table_con} ref={ref_list}>
        {data.map((item, i) => {
          let d = [];
          if (dataDescKey && dataDesc[item[dataDescKey]]) {
            d = dataDesc[item[dataDescKey]].data;
          }
          return (
            <Fragment key={i}>
              <div
                className={classnames(classes.g_table_item, props.widthStyle)}
                onClick={itemClick(item)}>
                {titles.map((it, n) => {
                  return (
                    <div
                      key={it.key + 'item' + n}
                      onClick={dataItemClick(item, it.onClick)}>
                      {it.render
                        ? it.render(item[it.key], item, i)
                        : item[it.key]}
                    </div>
                  );
                })}
              </div>
              <div
                className={classnames(classes.g_table_subitem, props.dataStyle)}
                style={{
                  height: d.length ? (d.length + 1) * props.listHeight : 0,
                }}>
                {d.length ? (
                  <div className={classnames(props.dataDescTitleStyle)}>
                    {titles2.map((item, i) => {
                      return (
                        <div key={item.key + 'title2' + i}>{item.title}</div>
                      );
                    })}
                  </div>
                ) : (
                  ''
                )}
                {d.length
                  ? d.map((itt, n) => {
                      return (
                        <div
                          className={props.dataDescStyle}
                          key={'dataDesc' + n}>
                          {titles2.map((it, m) => {
                            return (
                              <div key={itt[dataDescKey] + m}>
                                {it.render
                                  ? it.render(itt[it.key], itt, n)
                                  : itt[it.key]}
                              </div>
                            );
                          })}
                        </div>
                      );
                    })
                  : ''}
              </div>
            </Fragment>
          );
        })}
      </div>
    );
  };

  return (
    <div className={classes.g_table_box}>
      <div className={classnames(classes.g_table, props.className)}>
        {props.notitle || bodySize.width <= 800
          ? ''
          : renderTitle(props.titles)}
        <div>
          {props.loading ? (
            <p className={classes.g_table_loading}>
              {props.intl.formatMessage({ id: 'global.loading' })}
            </p>
          ) : (
            renderBody(props.data, props.dataDesc, props.dataDescKey)
          )}
        </div>
      </div>
      {props.totalPage < 2 || !props.data.length ? (
        ''
      ) : (
        <div className={classes.g_page}>
          <Pagination
            page={props.page}
            count={props.totalPage}
            shape='rounded'
            onChange={props.pageChange}
          />
        </div>
      )}
    </div>
  );
};

export default injectIntl(TableRC);
